<Modal title="Withdraw request" actionTitle="Withdraw" isDanger {isLoading} on:close={() => $uiState.activeModal = undefined} on:action={() => apply()}>
  <p class="block">
    Your request will be withdrawn and the business notified.
  </p>
  <p class="block">
    You cannot undo this action and you will not be able to make a new request for this offer.
  </p>
</Modal>

<script lang="ts">
  export let offerId : string, requestId : string;

  import { uiState } from '../../../../lib/uiState';
  import Modal from 'components/Modal.svelte';

  let isLoading = false;

  async function apply() {

    isLoading = true;

    let firebase = window.firebase;

    await firebase.functions().httpsCallable('api-request-withdrawrequest')({offerId, requestId} as WithdrawRequestParams);

    isLoading = false;

    $uiState.activeModal = undefined;
  }

</script>